// src/pages/ContactSubmitted.jsx
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/ApplicationForm.css";

/**
 * ContactSubmitted (Thank You Page) — cleaner + less busy
 *
 * Fixes:
 * - Adds top padding so your fixed header/nav doesn't overlap/cut the page title
 * - Reduces visual noise: fewer cards, less copy, better spacing
 * - Uses one primary CTA (Talk to Our Team) + one secondary (Home)
 * - Avoids the big "bar button" look by using a compact centered button
 */

const CALENDLY_URL = "https://calendly.com/leighton-jacobus/discovery-meeting";

const ContactSubmitted = () => {
  useEffect(() => {
    document.title = "Cause and Impact — Message Received";
  }, []);

  return (
    <div
      className="application-wrapper"
      style={{
        // Your nav is clearly fixed and overlapping content.
        // This padding pushes the card below the header safely.
        paddingTop: "110px",
        paddingBottom: "64px",
      }}
    >
      {/* Single, focused card */}
      <div
        className="application-form"
        style={{
          maxWidth: "780px",
          margin: "0 auto",
          padding: "30px 26px",
          borderRadius: "22px",
          background: "rgba(15, 23, 42, 0.55)",
          border: "1px solid rgba(255,255,255,0.06)",
          boxShadow: "0 18px 60px rgba(0,0,0,0.45)",
          backdropFilter: "blur(10px)",
        }}
      >
        {/* Top icon + title */}
        <div style={{ textAlign: "center", marginBottom: "22px" }}>
          <div
            aria-hidden="true"
            style={{
              width: "54px",
              height: "54px",
              borderRadius: "16px",
              margin: "0 auto 14px auto",
              display: "grid",
              placeItems: "center",
              background:
                "linear-gradient(135deg, rgba(99,102,241,0.35), rgba(139,92,246,0.28), rgba(20,184,166,0.24))",
              border: "1px solid rgba(255,255,255,0.08)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
            }}
          >
            <span style={{ fontSize: "26px", lineHeight: 1 }}>✓</span>
          </div>

          <h2
            style={{
              margin: 0,
              fontSize: "2.35rem",
              letterSpacing: "0.4px",
            }}
          >
            Message received
          </h2>

          <p
            style={{
              margin: "10px 0 0 0",
              color: "#cbd5e1",
              fontSize: "1.05rem",
              lineHeight: 1.6,
            }}
          >
            Thanks for reaching out to <strong>Cause and Impact</strong>.
            <br />
            We’ll reply within <strong>24–48 business hours</strong>.
          </p>
        </div>

        {/* Divider */}
        <div
          aria-hidden="true"
          style={{
            height: "1px",
            width: "100%",
            background: "rgba(255,255,255,0.06)",
            margin: "18px 0 22px 0",
          }}
        />

        {/* Primary CTA */}
        <div style={{ textAlign: "center" }}>
          <p style={{ margin: "0 0 14px 0", color: "#94a3b8" }}>
            Want to talk sooner?
          </p>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noreferrer"
            className="submit-button"
            style={{
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "12px 18px",
              borderRadius: "14px",
              minWidth: "230px",
              // Keep it from looking like a full-width "bar"
              width: "auto",
            }}
          >
            <span>Talk to Our Team</span>
            <span aria-hidden="true" style={{ opacity: 0.9 }}>
              ↗
            </span>
          </a>
        </div>

        {/* Secondary nav */}
        <div style={{ textAlign: "center", marginTop: "26px" }}>
          <Link
            to="/apply"
            style={{
              color: "#60a5fa",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "0.98rem",
            }}
          >
            Apply for Fiscal Sponsorship
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactSubmitted;